import {Component, OnInit} from '@angular/core';
import {FOOTER_CONFIG} from "../../../shared/interfaces";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {RegexEnum} from "../../../core/enums/regex.enum";
import {CustomerDoLogin, CustomerDoRegister, SetRequestProcessing} from "../../../states/auth/auth.actions";
import {AlertPopupService} from "../../../shared/services/alert-popup.service";
import {Store} from "@ngrx/store";
import {EmptyCriteria} from "../../../shared/interfaces/CriteriaModel";
import {take} from "rxjs";
import {RootService} from "../../services/root.service";

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
	public footerConfig = FOOTER_CONFIG;
	public form: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private alertPopupService: AlertPopupService,
		private store: Store,
		private rootService: RootService,
	) {
	}

	ngOnInit(): void {
		this.initializeForm();
	}

	public initializeForm(): void {
		this.form = this.formBuilder.group({
			name: [null, [Validators.required, Validators.email]],
		});
	}

	public markTouchedAndDirty(value: string | boolean, key: string, form: FormGroup): void {
		form.controls[key].markAsTouched();
		if (!value) {
			form.controls[key].markAsDirty();
		}
	}

	public onSubmit(form: FormGroup): void {
		try {
			if (form.valid) {
				this.store.dispatch(new SetRequestProcessing({
					requestProcessing: true
				}));
				this.rootService.subscribeNewsletter(form.value).pipe(take(1)).subscribe((resp: any) => {
					this.alertPopupService.showInfoAlert('You have been subscribed successfully.');
					this.form.reset();
					this.store.dispatch(new SetRequestProcessing({
						requestProcessing: false
					}));
				}, error => {
					this.store.dispatch(new SetRequestProcessing({
						requestProcessing: false
					}));
					this.alertPopupService.showErrorAlert(`${error.error.error.message}`);
				});
			} else {
				form.markAllAsTouched();
				// throw 'You missed to fill some required fields.';
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}
}
